import { render, staticRenderFns } from "./MessageNotifi.vue?vue&type=template&id=1e48d76a&scoped=true"
import script from "./MessageNotifi.vue?vue&type=script&lang=js"
export * from "./MessageNotifi.vue?vue&type=script&lang=js"
import style0 from "./MessageNotifi.vue?vue&type=style&index=0&id=1e48d76a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48d76a",
  null
  
)

export default component.exports